import { createAction } from '@reduxjs/toolkit';
import { storeName } from '../config';

export const changePage = createAction<number>(`${storeName}/changePage`);
